import confetti from 'canvas-confetti';

const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export function fireWinConfetti(origin?: { x: number; y: number }) {
  if (prefersReducedMotion()) return;

  const opts: confetti.Options = {
    particleCount: 120,
    spread: 70,
    startVelocity: 45,
    origin: origin ?? { x: 0.5, y: 0.45 },
    colors: ['#2e7d32', '#1976d2', '#ffc107', '#fff', '#66bb6a'],
  };

  void confetti(opts);
  window.setTimeout(() => {
    void confetti({ ...opts, particleCount: 80, spread: 55, startVelocity: 35 });
  }, 280);
}

export { prefersReducedMotion };
